import { CurrencyHelpers } from 'helpers/currencyHelpers';
export function priceInUSD(price) {
  return price?.centAmount / Math.pow(10, price?.fractionDigits);
}
export const priceFormat = (value?: number | null): string | null => {
  return typeof value === 'number' && value > 0 ? CurrencyHelpers.formatForCurrency(value * 100) : null;
};
